import { z } from "zod"
import { MediaFile } from "../../files/Models/MediaFile.js"
import type { PoapSeoType } from "@tutellus/schemas"

export const PoapSeoValidation = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  image: z.instanceof(MediaFile).optional(),
})

export class PoapSeo {
  constructor(
    private readonly _title?: string,
    private readonly _description?: string,
    private readonly _image?: MediaFile,
  ) {}

  static create({ title, description, image }: z.infer<typeof PoapSeoValidation>) {
    const { error, success } = PoapSeoValidation.safeParse({
      title,
      description,
      image,
    })
    if (!success) throw new Error(error.message)
    return new PoapSeo(title, description, image)
  }

  static createFromAPI(data: PoapSeoType) {
    return PoapSeo.create({
      title: data.title ?? undefined,
      description: data.description ?? undefined,
      image: data.image ? MediaFile.createFromAPI(data.image) : undefined,
    })
  }

  get title() { return this._title } // prettier-ignore
  get description() { return this._description } // prettier-ignore
  get image() { return this._image } // prettier-ignore

  serialize() {
    return {
      title: this.title ?? null,
      description: this.description ?? null,
      image: this.image?.serialize() ?? null,
    }
  }
}

export type PoapSeoSerialized = ReturnType<PoapSeo["serialize"]>
